import {ComponentFactory, ComponentFactoryResolver, NgModule} from '@angular/core';
import {SearchContentDataV2Service} from './services/search-content-data-v2.service';
import {StaticSearchContentDataV2Service} from './services/static-search-content-data-v2.service';
import {SharedModule} from '../../../../app-common/shared.module';
import {RouterModule} from '@angular/router';
import {SearchWidgetV2Module} from '../../../../components/search-widget-v2/search-widget-v2.module';
import {BookTimeNowModule} from '../../../../components/book-time-now/book-time-now.module';
import {SharedSearchModule} from '../../../../app-common/shared-search.module';
import {SearchContentMainComponent} from './components/search-content-main/search-content-main.component';
import {BookingBtnComponent} from '../../../../components/booking-btn/booking-btn.component';
import {InViewportDirective} from 'ng-in-viewport';
import {MatTabLink, MatTabNav, MatTabNavPanel} from '@angular/material/tabs';
import {CpruTabsService} from '../../../../services/cpru-tabs.service';
import {SearchContentTextSectionComponent} from './components/search-content-text-section/search-content-text-section.component';
import {SearchContentFactsV2Component} from './components/search-content-facts-v2/search-content-facts-v2.component';
import {SearchContentPlacesComponent} from './components/search-content-places/search-content-places.component';
import {SearchContentSummaryComponent} from './components/search-content-summary/search-content-summary.component';
import {SearchContentRelatedBlogV2Component} from './components/search-content-related-blog-v2/search-content-related-blog-v2.component';
import {SearchContentRelatedCausesV2Component} from './components/search-content-related-causes-v2/search-content-related-causes-v2.component';
import {SearchContentAdV2Component} from './components/search-content-ad-v2/search-content-ad-v2.component';
import {SearchContentSearchComponent} from './components/search-content-search/search-content-search.component';
import {SearchContentSchemaService} from './services/search-content-schema.service';
import {UiButtonComponent} from '../../../../components/ui/ui-button/ui-button.component';
import {UiIconComponent} from '../../../../components/ui/ui-icon/ui-icon.component';

@NgModule({
  providers: [SearchContentDataV2Service, StaticSearchContentDataV2Service, CpruTabsService, SearchContentSchemaService],
  imports: [
    RouterModule,
    SharedModule,
    SharedSearchModule,
    SearchWidgetV2Module,
    BookTimeNowModule,
    BookingBtnComponent,
    InViewportDirective,
    MatTabLink,
    MatTabNavPanel,
    MatTabNav,
    UiButtonComponent,
    UiIconComponent,
  ],
  declarations: [
    SearchContentMainComponent,
    SearchContentTextSectionComponent,
    SearchContentFactsV2Component,
    SearchContentPlacesComponent,
    SearchContentSummaryComponent,
    SearchContentRelatedBlogV2Component,
    SearchContentRelatedCausesV2Component,
    SearchContentAdV2Component,
    SearchContentSearchComponent,
  ],
  exports: [SearchContentMainComponent],
})
export class SearchContentPagesV2Module {
  constructor(private resolver: ComponentFactoryResolver) {}

  resolveComponentFactory(): ComponentFactory<SearchContentMainComponent> {
    return this.resolver.resolveComponentFactory(SearchContentMainComponent);
  }
}
